<template>
  <a-spin size="large" :spinning="loading">
    <div class="home">
      <div class="top-box">
        <p>
          <!-- <a-icon type="bar-chart" /> -->
          <span :class="[lang]"> 📊 {{ $t("Personalized") }}</span>
        </p>
        <div class="btn" @click="goBack" :class="[lang]">
          <a-icon type="arrow-left" class="icon" />
          <!-- <a-icon type="left" class="icon" /> -->
          <!-- <a-icon class="icon" type="step-forward" /> -->
          {{ $t("ReturnConsultation") }}
        </div>
      </div>
      <div class="main-box">
        <iframe
          id="myframe"
          class="frame"
          :style="{ height: maxWindowHeight + 'px' }"
        ></iframe>
        <div class="bottom">
          <a-button
            type="primary"
            :class="[lang]"
            @click="createCampaign"
            size="large"
            id="recruiter-create-btn"
          >
            {{ $t("CreateCampaign") }}
          </a-button>
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
import { mapGetters } from "vuex";

// import simplebar from "simplebar-vue";
// import "simplebar-vue/dist/simplebar.min.css";
// import { debounce } from "@/utils/util";
// import axios from "axios";
import { debounce } from "@/utils/util";

export default {
  data() {
    return {
      cancelSource: null,
      visible: false,
      // ws
      ws: null,
      // 打印机定时器
      PrintWords: null,
      btn_loading: false,
      //是否使用ws
      useWs: false,
      contentList: [],
      //要回答的内容
      content_chat: "",
      //左侧最高高度
      maxLeftHeight: 400,
      //是否显示补充模板
      showTempList: false,
      // 模板列表
      tempList: [],
      //模板Id
      template_id: null,
      //正在发送中
      sending: false,
      //任务Id
      task_id: null,
      // 当前会话id
      session_id: null,
      //显示finish按钮
      showFinish: false,

      //显示更多
      showMore: false,
      //email taskID
      email_taskId: null,
      loading: false,
      startTalk: false,
      bottomHeight: 0,
      width: "800px",
      showSendEmail: false,
      /* 选中的引导数据*/
      selectedGuideDate: null,
      defaultImg: require("@/assets/img/avat.png"),
      /* 当为输入框的时候*/
      messageInfo: "",
      noclick: true,
      maxWindowHeight: 700,
    };
  },
  components: {},
  computed: {
    ...mapGetters("account", ["user"]),
  },
  i18n: require("./i18n"),
  mounted() {
    this.resizeWindow2();
    window.addEventListener("resize", debounce(this.resizeWindow2, 300), false);

    let str = localStorage.getItem("htmlCont");
    var iframe = document.getElementById("myframe");
    var doc = iframe.contentWindow.document;
    if (iframe.contentDocument) {
      doc = iframe.contentDocument;
    }
    doc.open();

    doc.write(
      `${str
        .replace("max-width: 960px;", "")
        .replace("margin: 30px auto;", "")
        .replace("<REPORT_START>", "")
        .replace("<REPORT_END>", "")
        .replaceAll("<br>", "")}`
    );
    doc.close();
  },
  methods: {
    setScroll() {
      var scrollHeight = document.querySelector(
        ".simplebarWrap-dialog .simplebar-content-wrapper"
      ).scrollHeight;
      document.querySelector(
        ".simplebarWrap-dialog .simplebar-content-wrapper"
      ).scrollTop = scrollHeight;
    },
    goBack() {
      let { campaign_type } = this.$route.query;
      this.writeLog(
        "consultation",
        campaign_type == "1" ? "sales" : "recruiter",
        "return_to_consultation"
      );
      this.$router.go(-1);
    },
    resizeWindow2() {
      //this.$nextTick(() => {
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.maxLeftHeight = h - 104 - 48 - 49 - 30 - 60 - 40;

      let width = document.body.clientWidth - 254 - 60 + "px";
      this.$set(this.$data, "width", width);
      var bottomHeight = document.querySelector(".bottom")
        ? document.querySelector(".bottom").clientHeight
        : 0;
      this.bottomHeight = bottomHeight;
      let dialogHeight = h - bottomHeight - 40 - 138 - 10;
      let messageBoxHeight = 100;
      dialogHeight = dialogHeight - messageBoxHeight;
      // if (this.startTalk) {
      //   dialogHeight = dialogHeight - 48;
      // }
      this.maxWindowHeight = dialogHeight;
      // });
      //this.setScroll();
    },
    createCampaign() {
      let { campaign_type, session_id } = this.$route.query;
      this.writeLog(
        "consultation",
        campaign_type == "1" ? "sales" : "recruiter",
        "create_campaign"
      );
      if (campaign_type == "1") {
        if (this.user.has_customer_info) {
          this.$router.push({
            path: "/sales/salesReps/createCampaign",
            query: { linkedin_id: "new", report: 1, session_id },
          });
        } else {
          this.$router.push({
            path: "/sales/salesReps/collectUserInfo",
            query: { linkedin_id: "new", report: 1, session_id },
          });
        }
      } else {
        if (this.user.has_customer_info) {
          this.$router.push({
            path: "/hr/recruiter/createCampaign",
            query: { linkedin_id: "new", report: 1, session_id },
          });
        } else {
          this.$router.push({
            path: "/hr/recruiter/collectUserInfo",
            query: { linkedin_id: "new", report: 1, session_id },
          });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  padding: 20px 30px;
  display: flex;
  flex-flow: column;
}
.top-box {
  height: 138px;
  border-radius: 10px 10px 0px 0px;
  position: relative;
  background: linear-gradient(
    180.13deg,
    rgba(16, 117, 106, 0.74) 10.79%,
    rgba(16, 117, 117, 0) 99.89%
  );
  color: rgba(16, 16, 16, 1);
  font-size: 14px;

  p {
    padding-left: 30px;
    padding-top: 40px;
    font-weight: bold;
    font-size: 24px;
    text-align: left;
    color: rgba(16, 16, 16, 0.81);
  }
  .btn {
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 1);
    display: inline-block;
    position: absolute;
    cursor: pointer;
    right: 15px;
    top: 41px;
    .icon {
      margin-right: 5px;
    }
  }
}
.main-box {
  background: #fff;
  .bottom {
    padding: 20px 0 40px 0;
    text-align: center;
  }
  border-radius: 0px 0px 10px 10px;
}

.simplebarWrapLeft {
  width: 242px;
  /deep/.simplebar-scrollbar:before {
    background: #0e756a;
  }
}
.frame {
  border: none;
  width: 100%;
  height: 790px;
}
.simplebarWrap {
  /deep/.simplebar-scrollbar:before {
    background: #0e756a;
  }
  /* 定制滚动条轨道 */
  .simplebar-track.simplebar-vertical {
    width: 10px; /* 设置宽度 */
  }

  /* 定制滚动条滑块 */
  .simplebar-scrollbar.simplebar-vertical .simplebar-thumb {
    width: 10px; /* 设置滑块宽度 */
    background-color: red; /* 设置滑块颜色 */
    border-radius: 10px; /* 设置滑块圆角 */
  }

  /* 定制滚动条轨道和滑块的交界处 */
  .simplebar-track.simplebar-vertical .simplebar-scrollbar {
    border-radius: 10px; /* 设置圆角 */
  }
}
</style>
